import { getCountryCodeFromLocale, getLanguageCode, tokenize } from 'app/functions/string';
import { fetchCityRelationDetails } from './fetchCityRelationDetails';
import { AutocompleteResult } from 'app/models/types/store/location';
import { CitiesDetailsResponseCity } from '@webc/meeseeks-ui-sdk';

const buildRequestQuery = (locale: string) => {
  const queryString = new URLSearchParams();
  const languageCode = getLanguageCode(locale);
  const countryCode = getCountryCodeFromLocale(locale).toUpperCase();

  queryString.set('language', languageCode === 'en' ? 'en-gl' : languageCode);

  if (countryCode !== 'EN') {
    queryString.set('country', countryCode);
  }

  queryString.set('limit', '5');

  return queryString;
};

const getCity = (x: CitiesDetailsResponseCity, index: number): AutocompleteResult => ({
  ...x[0],
  legacyId: x[0].legacy_id,
  country: x[0].country_code,
  hash: index.toString(),
  score: 0,
  continent: '',
  _tokenizedLabel: tokenize(x[0].name),
  subdivisionCode: x[0].subdivision_code,
});

export const fetchPopularCities = (
  recommendationURl: string,
  citiesDetailsEndpoint: string,
  locale: string,
  cityId?: string,
): Promise<AutocompleteResult[]> => {
  const requestQuery = buildRequestQuery(locale);
  const url = cityId ? `${recommendationURl}/${cityId}/reachable` : recommendationURl;

  return fetch(`${url}?${requestQuery}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then(async (jsonResponse) => {
      const requests = jsonResponse.result.map((x: { id: number }) => {
        return fetchCityRelationDetails(citiesDetailsEndpoint, x.id, locale);
      });
      const cities: CitiesDetailsResponseCity[] = await Promise.all(requests);
      return cities.map(getCity);
    });
};
